<style lang="less" scoped>
.margin-tb {
  height: 32px;
  margin-top: 4px;
}

.query-title-div {
  width: 90px !important;
}
.topList {
  height: 175px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  .topList-div {
    width: 30%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #4182eb;
    border-radius: 22px;
    div {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      &:first-child {
        width: 35%;
        padding: 10px;
        // text-align: center;
        height: 80%;
        color: white;
        font-weight: 600;
        p:nth-child(1) {
          width: 38px;
          height: 38px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        p:nth-child(3) {
          font-size: 23px;
        }
      }
      &:last-child {
        flex: 1;
        height: 80%;
        border-left: 1px solid rgba(255, 255, 255, 0.404);
        color: white;
        p {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          box-sizing: border-box;
        }
      }
    }
  }
  .topList-div3 {
    width: 30%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #4182eb;
    border-radius: 22px;
    div {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: flex-start;
      // text-align: center;
      &:first-child {
        width: 50%;
        padding: 10px;
        // text-align: center;
        height: 80%;
        color: white;
        font-weight: 600;
        border-right: 1px solid rgba(255, 255, 255, 0.404);
        padding: 20px;
        box-sizing: border-box;
        p:nth-child(1) {
          width: 38px;
          height: 38px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        p:nth-child(3) {
          font-size: 23px;
        }
      }
      &:last-child {
        width: 50%;
        padding: 10px;
        // text-align: center;
        height: 80%;
        color: white;
        font-weight: 600;
        padding: 20px;
        box-sizing: border-box;
        p:nth-child(1) {
          width: 38px;
          height: 38px;
          background-color: white;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        p:nth-child(3) {
          font-size: 23px;
        }
      }
    }
  }
}
.reportDiv {
  width: 100%;
  height: 450px;
  overflow: auto;
  // padding: 20px;
  border: 1px solid #e6e8ef;
  margin-top: 20px;
  border-radius: 7px;
  .reportDiv-List {
    width: 100%;
    padding:20px;
    box-sizing: border-box;
    .top{
        display: flex;
        div{
            width: 15%;
            font-size: 16px;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            color: #8F9BB3;
            &:last-child{
                font-size: 20px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                color: #4182EB;
                letter-spacing: 1px;
            }
        }
      }
    .list {
      display: flex;
      justify-content: space-between;
      align-items: center;
     
      .list-left {
        width: 20%;
        // border: 1px solid #e6e8ef;
        border-radius: 14px;
        height: 210px;
        overflow: hidden;
        div:last-child {
          p {
            display: flex;
            justify-content: space-around;
            align-items: center;
            font-size: 16px;
            height: 16px;
            line-height: 16px;
            margin: 20px 0;
            span:nth-child(1) {
              display: block;
              width: 40%;
            }
            span:nth-child(2) {
              display: block;
              width: 20%;
            }
            span:nth-child(3) {
              display: block;
              width: 20%;
            }
          }
        }
      }
      .list-right {
        width: 60%;
        height: 260px;
        // border: 1px solid #e6e8ef;
        border-radius: 14px;
        overflow: hidden;
        .registration-trends {
          width: 100%;
          height: 257px;
        }
      }
      .list-right2 {
        width: 20%;
        height: 180px;
        overflow: hidden;
        p {
            display: flex;
            justify-content: space-around;
            align-items: center;
            font-size: 16px;
            height: 16px;
            line-height: 16px;
            margin: 20px 0;
            span:nth-child(1) {
              display: block;
              width: 20%;
            }
            span:nth-child(2) {
              display: block;
              width: 50%;
              display: flex;
              justify-content: flex-end;
              align-content: center;
            }
            span:nth-child(3) {
              display: block;
              width: 17px;
              height: 17px;
              // background: #BB87F3;
            border-radius: 4px;
            }
            &:nth-child(1) {
            span:nth-child(3) {
              background: #bb87f3;
            }
          }
          &:nth-child(2) {
            span:nth-child(3) {
              background: #22c6be;
            }
          }
          &:nth-child(3) {
            span:nth-child(3) {
              background: #1677ff;
            } 
          }
          &:nth-child(4) {
            span:nth-child(3) {
              background: #4cd533;
            }
          }
          // &:nth-child(5) {
          //   span:nth-child(3) {
          //     background: #09c5ff;
          //   }
          // }
          }
      }
    }
    .to-List{
        width: 100%;
        // height: 60px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        
    }
  }
}


.blue {
  background: #4182eb !important;
  color: white !important;
  border: none;
}
.gray {
  background: #e7e7e8 !important;
  border: none;
  color: #9ba5ba;
  // color: white !important;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title">充电订单报表</div>

      <!-- 报表 -->
      <div class="reportDiv">
        <div class="topTitle">
          <div>{{ detailInfo.pileOrderTypeDto.statisDate }}</div>
          <div>
            <el-button
              :class="daysChange ? 'blue' : 'gray'"
              type="primary"
              @click="handleDateChange"
              round
              >近七天</el-button
            >
            <el-button
              :class="!daysChange ? 'blue' : 'gray'"
              type="primary"
              @click="handleDateChange"
              round
              >近三十天</el-button
            >
          </div>
        </div>
        <!-- 用户访问 -->
        <div class="reportDiv-List">
            <div class="top">
                <div>充电订单总数</div>
                <div><span>{{ detailInfo.pileOrderTypeDto.chargeCountAll | numberToCurrency}}</span></div>
              </div>
          <div class="list">
            <div class="list-left">
              
              <div>
                <p>
                  <span></span>
                  <span>数量</span>
                  <span>占比</span>
                </p>
                <p>
                  <span>桩主充电订单数</span>
                  <span>{{ detailInfo.pileOrderTypeDto.chargeCountMaster| numberToCurrency }}</span>
                  <span>{{ detailInfo.pileOrderTypeDto.ratioMaster |numFilter}}%</span>
                </p>
                <p>
                  <span>亲友充电订单数</span>
                  <span>{{ detailInfo.pileOrderTypeDto.chargeCountFamily | numberToCurrency}}</span>
                  <span>{{ detailInfo.pileOrderTypeDto.ratioFamily |numFilter}}%</span>
                </p>
                <p>
                  <span>私桩共享充电订单数</span>
                  <span>{{ detailInfo.pileOrderTypeDto.chargeCountShare | numberToCurrency}}</span>
                  <span>{{ detailInfo.pileOrderTypeDto.ratioShare |numFilter}}%</span>
                </p>
                
              </div>
            </div>
            <div class="list-right">
              <div class="registration-trends" id="RegistrationTrends"></div>
            </div>
            <div class="list-right2">
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange1"
                    v-model="checkbox1"
                  ></el-checkbox
                ></span>
                <span>全部充电订单</span>
                <span></span>
              </p>
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange2"
                    v-model="checkbox2"
                  ></el-checkbox
                ></span>
                <span>桩主充电订单</span>
                <span></span>
              </p>
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange3"
                    v-model="checkbox3"
                  ></el-checkbox
                ></span>
                <span>亲友充电订单</span>
                <span></span>
              </p>
              <p>
                <span
                  ><el-checkbox
                    @change="handleCheckboxChange4"
                    v-model="checkbox4"
                  ></el-checkbox
                ></span>
                <span>私桩共享充电订单</span>
                <span></span>
              </p>
               
            </div>
          </div>
          <div class="to-List"><el-button type="primary" @click="toList">数据列表</el-button></div>
        </div>
      </div>
     
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
// import dateUtil from "../../../utils/dateUtils";
import { EleResize } from "../../../config/esresize";
import * as echarts from "echarts";
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      daysChange: true,
      checkbox1:true,
      checkbox2:false,
      checkbox3:false,
      checkbox4:false,
      detailInfo:{
        pileOrderTypeDto:{
          chargeCountAll:'',
          chargeCountMaster:'',
          ratioMaster:'',
          chargeCountFamily:'',
          ratioFamily:'',
          chargeCountShare:'',
          ratioShare:'',
          pileOrderTypeList:[]
        }
      },
      // 充电订单列表
      pileOrderTypeStatisDate:[],
      pileOrderTypeField_20:[],

      pilebindCountZdApp:[],
      pilebindCountZdjApp:[],
      pilebindCountZdAli:[],
      pilebindCountZdWeChat:[],
      countChangeList:[],
      countColor:'#bb87f3'
    };
  },
  methods: {
    // 判断页面路由是否存在手机号码/站点编号
    init() {
      // 获取用户注册趋势
      // this.getRegistrationTrends();
    },
    //选择系统日期时间
    handleDateChange(val) {
      this.daysChange = !this.daysChange;
      console.log(this.checkbox1);
      this.getData()
    },
    toList(){
      let _ = this;
      var url = _.$router.resolve({ name: "orderTypeList", query: { daysChange: _.daysChange } });
      window.open(url.href, "_blank");
    },
    //表格详情
    toDetail(val) {
      let _ = this;
      var url = _.$router.resolve({ name: "orderDetail", query: { id: val } });
      window.open(url.href, "_blank");
    },
    getWeek() {
      let time = new Date().getTime();
      let endTime = time - 6 * 24 * 3600 * 1000;
      this.startDate = this.$dayjs(endTime).format("YYYY-MM-DD");
      this.endDate = this.$dayjs(time).format("YYYY-MM-DD");
      console.log(this.startDate); // 开始时间
      console.log(this.endDate); // 结束时间
    },
    getMonth() {
      let time = new Date().getTime();
      let now = new Date(); // 当前日期
      let nowMonth = now.getMonth(); // 当前月
      let nowYear = now.getFullYear(); // 当前年
      let monthStartDate = new Date(nowYear, nowMonth, 1);
      let monthEndDate = new Date(nowYear, nowMonth + 1, 0);
      this.startDate = this.$dayjs(monthStartDate).format("YYYY-MM-DD");
      this.endDate = this.$dayjs(monthEndDate).format("YYYY-MM-DD");
    },
    getData() {
      let _ = this;
      if (this.daysChange) {
        this.getWeek();
      } else {
        this.getMonth();
      }
      let obj = {
        startDate: _.startDate,
        endDate: _.endDate,
      };
      _.pileOrderTypeStatisDate = []
      _.pileOrderTypeField_20 = []
      _.pilebindCountZdApp=[]
      _.pilebindCountZdjApp=[]
      _.pilebindCountZdAli=[]
      _.$H.post(_, _.$A.operateStatis.pileOrderTypeChart, obj).then((res) => {
        _.detailInfo = res.data.data;
         // 充电订单类型
         _.detailInfo.pileOrderTypeList.forEach(item=>{
          _.pileOrderTypeStatisDate.push(item.statisDate)
          // _.pileOrderTypeField_20.push(item.field_20)
          _.pileOrderTypeField_20.push(item.chargeCountAll)
          if (_.checkbox1) {
            _.pileOrderTypeField_20.push(item.chargeCountAll)
          }else{
            _.pileOrderTypeField_20 = []
          }
          if (_.checkbox2) {
            _.pilebindCountZdApp.push(item.chargeCountMaster);
          }
          if (_.checkbox3) {
            _.pilebindCountZdjApp.push(item.chargeCountFamily); 
          }
          if (_.checkbox4) {
            _.pilebindCountZdAli.push(item.chargeCountShare);
          }
        })

        _.getRegistrationTrends1()
       
      });
    },
    handleCheckboxChange1() {
      let _ = this;

      if (_.checkbox1) {
        _.checkbox2 = false
        _.pilebindCountZdApp =[]
        _.checkbox3 = false
        _.pilebindCountZdjApp = []
        _.checkbox4 = false
        _.pilebindCountZdAli = []
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.pileOrderTypeField_20 = []
        _.pileBindStatisDate = []
        _.$H.post(_, _.$A.operateStatis.pileOrderTypeChart, obj).then((res) => {
          _.detailInfo = res.data.data;
          // 用户绑定
          _.detailInfo.pileOrderTypeList.forEach((item) => {
            // 绑定
            _.pileBindStatisDate.push(item.statisDate);
            _.pileOrderTypeField_20.push(item.chargeCountAll);

          });
          _.getRegistrationTrends1()
        });
      }else{
        _.pileOrderTypeField_20 = []
        _.getRegistrationTrends1()
      }
    },
    handleCheckboxChange2() {
      let _ = this;
      if (_.checkbox2) {
        _.checkbox1 = false
        _.pileOrderTypeField_20 = []
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.pilebindCountZdApp =[]
        _.pileBindStatisDate = []
        _.$H.post(_, _.$A.operateStatis.pileOrderTypeChart, obj).then((res) => {
          _.detailInfo = res.data.data;
          // 用户绑定
          _.detailInfo.pileOrderTypeList.forEach((item) => {
            // 挚达App绑定
            _.pileBindStatisDate.push(item.statisDate);
            _.pilebindCountZdApp.push(item.chargeCountMaster);
          });
          _.getRegistrationTrends1()
        });
      }else{
        _.pilebindCountZdApp = []
        _.getRegistrationTrends1()
      }
    },
    handleCheckboxChange3() {
      let _ = this;
      if (_.checkbox3) {
        _.checkbox1 = false
        _.pileOrderTypeField_20 = []
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.pilebindCountZdjApp = []
        _.pileBindStatisDate = []
        _.$H.post(_, _.$A.operateStatis.pileOrderTypeChart, obj).then((res) => {
          _.detailInfo = res.data.data;
          // 用户绑定
          _.detailInfo.pileOrderTypeList.forEach((item) => {
            // 桩到家App绑定
            _.pileBindStatisDate.push(item.statisDate);
            _.pilebindCountZdjApp.push(item.chargeCountFamily); 
          });
          _.getRegistrationTrends1()
        });
      }else{
        _.pilebindCountZdjApp = []
        _.getRegistrationTrends1()
      }
    },
    handleCheckboxChange4() {
      let _ = this;
      if (_.checkbox4) {
        _.checkbox1 = false
        _.pileOrderTypeField_20 = []
        if (_.daysChange) {
          _.getWeek();
        } else {
          _.getMonth();
        }
        let obj = {
          startDate: _.startDate,
          endDate: _.endDate,
        };
        _.pilebindCountZdAli = []
        _.pileBindStatisDate = []
        _.$H.post(_, _.$A.operateStatis.pileOrderTypeChart, obj).then((res) => {
          _.detailInfo = res.data.data;
          // 用户绑定
          _.detailInfo.pileOrderTypeList.forEach((item) => {
            // 支付宝绑定
            _.pileBindStatisDate.push(item.statisDate);
            _.pilebindCountZdAli.push(item.chargeCountShare);
          });
          _.getRegistrationTrends1()
        });
      }else{
        _.pilebindCountZdAli = []
        _.getRegistrationTrends1()
      }
    },
    // 充电订单
    getRegistrationTrends1() {
      // 基于准备好的dom，初始化echarts实例
      let changeChart = this.$echarts.init(
        document.getElementById("RegistrationTrends")
      );
      // 绘制图表
      changeChart.setOption({
        tooltip: {
          trigger: "axis",
          // backgroundColor:'transparent',
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#f6eefd", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "#dec8f5", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#cfabf7", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        },
        xAxis: {
          type: "category",
          axisLine: {
            show: false,
          },
          data: this.pileOrderTypeStatisDate,
        },
        yAxis: {
          type: "value",
          max: 100000, //最大值
          min: 0, //最小值
          interval: 20000, //间隔

          //坐标轴最大值、最小值、强制设置数据的步长间隔
          // interval: 5,
          // axisLabel: {
          //     //y轴上带的单位
          //     formatter: '{value}'
          // },
          //轴线
          axisLine: {
            show: true,
          },
          // //分割线
          // splitLine: {
          //     show: false
          // }
        },
      //   _.pileOrderTypeField_20 = []
      // _.pilebindCountZdApp=[]
      // _.pilebindCountZdjApp=[]
      // _.pilebindCountZdAli=[]
        series: [
          {
            data: this.pileOrderTypeField_20,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: '#bb87f3', //改变折线点的颜色
                lineStyle: {
                  color: '#bb87f3', //改变折线颜色
                },
              },
            },
          },
          {
            data: this.pilebindCountZdApp,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: '#22c6be', //改变折线点的颜色
                lineStyle: {
                  color: '#22c6be', //改变折线颜色
                },
              },
            },
          },
          {
            data: this.pilebindCountZdjApp,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: '#1677ff', //改变折线点的颜色
                lineStyle: {
                  color: '#1677ff', //改变折线颜色
                },
              },
            },
          },
          {
            data: this.pilebindCountZdAli,
            type: "line",
            // showSymbol: false,
            symbolSize: 3,
            symbol: "circle",
            itemStyle: {
              normal: {
                color: '#4cd533', //改变折线点的颜色
                lineStyle: {
                  color: '#4cd533', //改变折线颜色
                },
              },
            },
          },
        ],
      });
      setTimeout(() => {
        window.addEventListener("resize", function() {
          changeChart.resize();
        });
      }, 500);
    },
    


    // echarts 实例
    drawECharts(dom, option) {
      let myChart = this.$echarts.init(document.getElementById(dom));
      let resizeDiv = document.getElementById(dom);
      resizeDiv.removeAttribute("_echarts_instance_");
      // 绘制图表
      myChart.setOption(option);
      let listener = () => {
        myChart.resize();
      };
      EleResize.on(resizeDiv, listener);
    },
  },
  mounted() {
    this.init();
    this.getData()
    this.getRegistrationTrends1();
   
  },
};
</script>
